import {createContext} from 'react';

export type OrganizationSignUpContextType = {
	nextStepHandler: (step: number) => void;
	activeStep: number;
};

export const OrganizationSignUpContext = createContext({} as OrganizationSignUpContextType);
